import httpService from "@src/utility/httpService";
import { VBC_PROGRAM_DETAILS } from '@src/CommonComponents/constant/api_url_constants';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';

export interface ActiveProgramRow {
  ProgramName?: string;
  SubProgramName?: string;
  Lob?: string;
  ContractOriginDate?: string | null;
  ContractProgramTimeframe?: string | null;
  PayeeName?: string;
  TinDetails?: unknown[];
  [key: string]: unknown;
}

interface ApiResponse<T> {
  StatusCode?: number;
  Data?: T;
  [key: string]: unknown;
}

interface HttpErrorLike {
  response?: {
    data?: unknown;
    status?: number;
  };
  message?: string;
}
// Removed local vbcTableConfig duplicate; use shared config in constants (import where needed in components)

const _httpService = new httpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') || '');
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') || '');
}


// API service function for fetching Active Programs data
export const getActiveProgramsData = async (payload: Record<string, unknown> = {}) => {
  try {
    const responseData: ApiResponse<ActiveProgramRow[] | null> = await _httpService.push(VBC_PROGRAM_DETAILS, payload);
    return responseData;
  } catch (error: unknown) {
    const httpErr = error as HttpErrorLike;
    console.error('Error details:', {
      message: httpErr?.message,
      response: httpErr?.response?.data,
      status: httpErr?.response?.status
    });
    return null;
  }
};

// API service function for fetching glossary data
export const fetchGlossaryData = async (): Promise<unknown[]> => {
  try {
  const response: ApiResponse<unknown[]> = await _httpService.get('/metric-definitions/');

    if (response?.StatusCode === 200 && Array.isArray(response.Data)) {
      return response.Data;
    } else {
      console.error('Failed to fetch glossary data. Invalid response:', response);
      return [];
    }
  } catch (error: unknown) {
    const httpErr = error as HttpErrorLike;
    console.error('Error occurred while fetching glossary data:', {
      message: httpErr?.message,
      response: httpErr?.response?.data,
      status: httpErr?.response?.status
    });
    return [];
  }
};
